<div mat-dialog-title style="height: 10px !important;">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: relative;margin-top: 20px;">
    <div class="close-dialog" mat-dialog-close>
      <span class="material-symbols-outlined">close</span>
    </div>
  </div>
</div>

<mat-dialog-content>

  <div style="text-align: center;">

    @if (pausa_status == false && show_extra != 'bang bang') {
      <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
        <span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color6)">info</span>
      </div>
    }

    @if (pausa_status == true && show_extra != 'bang bang') {
      <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
        <span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color7)">check_circle</span>
      </div>
    }

    @if (show_extra == 'bang bang') {
      <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
        <span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color6)">checklist</span>
      </div>
    }

    <div class="label-dialog-strong">{{title}}</div>
    <div class="label-dialog" [innerHTML]="subtitle"></div>

    @if (show_extra) {
      <div class="label-dialog" style="margin-top: 20px;text-decoration: underline;color:var(--simpli-secondary);font-size: 15px;cursor: pointer;" (click)="que_es_reemitir()">
        Descubre cómo reemitir las facturas en el SII
      </div>
    }


    <div class="row">
      @if (show_extra == false) {
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            <button class="primary-button" mat-flat-button (click)="ver_detalle()">
              Ver detalle
            </button>
            <button class="secondary-button" mat-flat-button mat-dialog-close>
              Ver mis operaciones
            </button>
          </div>
        </div>
      }

      @if (show_extra == true) {
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container" style="margin-bottom: 30px;">
            @if (pausa_status == false) {
              <button class="primary-button" mat-flat-button (click)="reemitir_facturas()">
                Reemitir facturas
              </button>
            }
            @if (pausa_status == false) {
              <button class="secondary-button" mat-flat-button (click)="continuar_cesion()">
                Continuar cesión
              </button>
            }
            @if (pausa_status == true) {
              <button class="primary-button" mat-flat-button (click)="close_and_recharge()">
                Ver mis operaciones
              </button>
            }
            @if (pausa_status == true) {
              <button class="secondary-button" mat-flat-button (click)="reactivar()">
                Reactivar operación
              </button>
            }
          </div>
          @if (pausa_status == false) {
            <div class="label-dialog" style="margin-bottom: 40px;font-size: 15px;">
              Si lo necesitas, puedes <span (click)="pausar_operacion()" style="text-decoration: underline;color:var(--simpli-secondary);cursor: pointer;">pausar la operación.</span>
            </div>
          }
        </div>
      }

      @if (show_extra == null) {
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            <button class="primary-button" mat-flat-button style="width: 230px;" (click)="reemitir_final()">
              Reemitir facturas en el SII
            </button>
          </div>
          <div class="label-dialog" style="margin-bottom: 40px;font-size: 15px;">
            Si usas un facturador externo, <span (click)="contactar()" style="text-decoration: underline;color:var(--simpli-secondary);cursor: pointer;">contacta a tu ejecutivo.</span>
          </div>
        </div>
      }

      @if (show_extra == 'bang bang') {
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            <button class="primary-button" mat-flat-button style="width: 245px;" (click)="agregar_mas_facturas()">
              Facturas reemitidas
            </button>
            <button class="secondary-button" mat-flat-button style="width: 245px;" (click)="continuar_cesion()">
              Continuar cesión
            </button>
          </div>
        </div>
      }
    </div>



  </div>



</mat-dialog-content>
